var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalRoots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3337 11.6666C23.3337 17.4918 16.8715 23.5584 14.7015 25.4321C14.4993 25.5841 14.2533 25.6663 14.0003 25.6663C13.7474 25.6663 13.5013 25.5841 13.2992 25.4321C11.1292 23.5584 4.66699 17.4918 4.66699 11.6666C4.66699 9.19123 5.65032 6.81726 7.40066 5.06692C9.151 3.31658 11.525 2.33325 14.0003 2.33325C16.4757 2.33325 18.8496 3.31658 20.6 5.06692C22.3503 6.81726 23.3337 9.19123 23.3337 11.6666Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.1667C15.933 15.1667 17.5 13.5997 17.5 11.6667C17.5 9.73375 15.933 8.16675 14 8.16675C12.067 8.16675 10.5 9.73375 10.5 11.6667C10.5 13.5997 12.067 15.1667 14 15.1667Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalRoots);
export default __webpack_public_path__ + "static/media/local-roots.4c755343fb65481df0973883e49a3982.svg";
export { ForwardRef as ReactComponent };